import React, {forwardRef, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {BaseComponent} from 'web/components/BaseComponent';
import useAssignmentHistory from '../hooks/useAssignmentHistory';
import DataTableComponent from 'web/components/DataTableComponent';
import enumList from 'web/utils/enumList';
import moment from 'moment-timezone';

const {moduleEnums, accessModeEnums} = enumList;

const AssignmentHistoryModal = (props, ref) => {
  const {machineID, setMachineID} = props;
  const dispatch = useDispatch();
  const baseComponent = new BaseComponent(props);
  const {fetchBindingHistories, getStates: getAssignmentHistoryStates} =
    useAssignmentHistory({dispatch});
  const histories = getAssignmentHistoryStates(({histories}) => histories);
  const dataTableConfigs = {
    paging: true,
    scrollX: true,
  };

  const columnConfigs = [
    {title: '日期時間', className: 'dt-center', data: 'createTime'},
    {title: '客戶編號', className: 'dt-center', data: 'customerCode'},
    {title: '客戶姓名', className: 'dt-center', data: 'customerName'},
    {
      title: '類別',
      className: 'dt-center',
      data: 'eventType',
      className: 'dt-center',
    },
    {
      title: '保固起始日',
      className: 'dt-center',
      data: 'deliveryDate',
      className: 'dt-center',
    },
    {
      title: '是否轉售',
      className: 'dt-center',
      data: 'flgIsResold',
      className: 'dt-center',
    },
    {
      title: '是否需要外勤確認',
      className: 'dt-center',
      data: 'flgOnSiteCheck',
      className: 'dt-center',
    },
  ];

  const slotConfigs = {
    0: (createTime) => (
      <>{moment.tz(createTime, 'utc').format('YYYY-MM-DD HH:mm:ss.SSS')}</>
    ),
    3: (eventType, rowIndex) => {
      switch (eventType) {
        case 'create':
          return <div className="status status-normal">綁定</div>;
        case 'delete':
          return <div className="status status-danger">解除綁定</div>;
        default:
          console.warn(`Unknown eventType \'${eventType}\' in row ${rowIndex}`);
          return <></>;
      }
    },
    4: (deliveryDate) => (
      <>
        {deliveryDate
          ? moment.tz(deliveryDate, 'utc').format('yyyy-MM-DD')
          : '-'}
      </>
    ),
    5: (flgIsResold, rowIndex) => {
      switch (flgIsResold) {
        case 'Y':
          return <div className="status status-normal">轉售</div>;
        case 'N':
          return <div className="status status-danger">未經轉售</div>;
        default:
          console.warn(
            `Unknown flgIsResold \'${flgIsResold}\' in row ${rowIndex}`,
          );
          return <></>;
      }
    },
    6: (flgOnSiteCheck, rowIndex) => {
      switch (flgOnSiteCheck) {
        case 'Y':
          return <div className="status status-normal">需要</div>;
        case 'N':
          return <div className="status status-danger">不需要</div>;
        default:
          console.warn(
            `Unknown flgOnSiteCheck \'${flgOnSiteCheck}\' in row ${rowIndex}`,
          );
          return <></>;
      }
    },
  };

  useEffect(() => {
    baseComponent.checkPermission(moduleEnums.machine, accessModeEnums.read);
    if (!machineID) {
      return;
    }
    fetchBindingHistories(machineID);
  }, [machineID]);

  useEffect(() => {
    const cleanOnClose = () => {
      setMachineID();
    };
    if (!(ref.current instanceof HTMLDivElement)) {
      return;
    }
    ref.current.addEventListener('hidden.bs.modal', cleanOnClose);
    return () => {
      if (!(ref.current instanceof HTMLDivElement)) {
        return;
      }
      ref.current.removeEventListener('hidden.bs.modal', cleanOnClose);
    };
  }, []);

  return (
    <div
      ref={ref}
      className="modal fade"
      id="machine-modal-assignment-histories"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
    >
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div
          className="modal-content"
          id="machine-modal-assignment-histories-content"
        >
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="modalMachineLabel">
              <div className="modal__title__text">機器綁定記錄</div>
            </h1>
            <button
              type="button"
              className="btn-close btn-cancel"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body datatable-container">
            <div className="datatable__data">
              <DataTableComponent
                data={histories}
                slots={slotConfigs}
                columns={columnConfigs}
                options={dataTableConfigs}
                className="display table table-hover align-middle nowrap"
              >
                <thead>
                  <tr>
                    <th>日期時間</th>
                    <th>客戶編號</th>
                    <th>客戶姓名</th>
                    <th>類別</th>
                    <th>保固起始日</th>
                    <th>是否轉售</th>
                    <th>是否需要外勤確認</th>
                  </tr>
                </thead>
              </DataTableComponent>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default forwardRef(AssignmentHistoryModal);
